import { gql } from '@apollo/client';

export const residualValueGridFragment = gql`
  fragment residualValueGrid on ResidualValueGrid {
    id
    code
    name
    fromDate
    toDate
    isActive
    applicableToId
    applicableToName
    maximumIncrease
    maximumDecrease
    netRiskValue
    assetLevelResidualValues
    isEditable
  }
`;
